export default __webpack_public_path__ + "static/media/journey_sl_active.27f4ffdd.png";